export default __webpack_public_path__ + "static/ellipse-d54f0c8bd5faa0fedc5f65e1c5b8b259.png";